import React, { useEffect, useRef } from 'react';
import { useThreeRenderer } from '../../rendering/ThreeRenderer';

// 開発用ページ（/drawing-builder・/capture-figures）で、モデルを1枚分描画するための部品。
// ready になったら描画が落ち着くのを待って onReady({ renderer, scene, camera }) を呼ぶだけ。
// 800×600 固定：学習者に見せるデッサン画像はこの大きさ・既定視点で作る（config/drawings.js）。
export const CANVAS_W = 800;
export const CANVAS_H = 600;
const SETTLE_MS = 700; // モデル追加後、描画が落ち着くまでの待ち

export default function RenderUnit({
  glbPath, shearValue, showGrid = false, addColor, cameraPosition, cameraTarget, onReady,
}) {
  const canvasRef = useRef(null);
  const { renderer, scene, camera, isRendererReady } = useThreeRenderer(
    glbPath, canvasRef, true, showGrid, false, shearValue, addColor, cameraPosition, cameraTarget
  );

  useEffect(() => {
    if (!isRendererReady || !renderer || !scene || !camera) return;
    const timer = setTimeout(() => onReady({ renderer, scene, camera }), SETTLE_MS);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRendererReady, renderer, scene, camera]);

  return (
    <canvas
      ref={canvasRef}
      width={CANVAS_W}
      height={CANVAS_H}
      style={{ width: `${CANVAS_W}px`, height: `${CANVAS_H}px`, border: '1px solid #ccc' }}
    />
  );
}

// 描画済みのシーンを PNG の Blob にする
export async function snapshot({ renderer, scene, camera }) {
  await new Promise((resolve) => requestAnimationFrame(() => {
    renderer.render(scene, camera);
    resolve();
  }));
  const blob = await new Promise((resolve) => renderer.domElement.toBlob(resolve, 'image/png'));
  if (!blob) throw new Error('toBlob returned null');
  return blob;
}
